import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Chip from "./Chip";
import { ChipGroupProps } from "./PropsType";

export default function ChipGroup(props: ChipGroupProps) {
  const { className, placeholder } = props;
  const [data, setData] = useState(
    Array.isArray(props.data!) ? props.data : []
  );
  const [value, setValue] = useState('');
  const [focus, setFocus] = useState(!!props.focus);
  const inputRef = useRef(null);
  const styleClass = classNames(
    "ChipGroup",
    {
      "Chip-input": !!placeholder,
      "Chip-focus": focus,
    },
    className
  );
  const chipData = data;

  const handleDelete = (data: any) => {
    const chipData = [...data!];
    const chipToDelete = chipData.indexOf(data);
    chipData.splice(chipToDelete, 1);
    setData(chipData);
    if (props.onDelete) {
      props.onDelete({
        label: data.label!,
        value: data.value!,
      });
    }
  };

  const handleClick = (data: any) => {
    if (props.onClick) {
      props.onClick({
        label: data.label!,
        value: data.value!,
      });
    }
  };

  const handleFocus = () => {
    setFocus(!focus);
  };

  const handleChange = (event: any) => {
    const target: any = event.target;
    const value = target.value;
    setValue(value);
  };

  const handleKeyUp = (event: any) => {
    if (event.keyCode === 13) {
      const target: any = event.target;
      let value = target.value;
      const chipData = [...data!];
      chipData.push({
        label: value,
        value: value,
      });
      value = "";
      setValue(value);
      setData(chipData);
    }
  };

  useEffect(() => {
    setData(props.data || []);
  }, [props.data]);

  return (
    <div className={styleClass}>
      {chipData.map((node, index) => {
        return (
          <Chip
            key={index}
            {...node}
            onDelete={handleDelete.bind(null, node)}
            onClick={handleClick.bind(null, node)}
          />
        );
      })}
      {placeholder ? (
        <input
          value={value}
          ref={inputRef}
          spellCheck={false}
          type="text"
          placeholder={placeholder}
          onKeyUp={handleKeyUp}
          onChange={handleChange}
          onFocus={handleFocus}
        />
      ) : null}
    </div>
  );
}
